import 'isomorphic-fetch';
import { getConfigurationByEnv } from '../config/myvw-configs';

export async function fetchLaunchDarklyClientConfig(
  baseUrl?: string,
): Promise<string> {
  const configJson = getConfigurationByEnv(baseUrl);
  const response = await fetch(`${configJson.url}/clientConfig`);
  if (!response.ok) {
    throw new Error('Failed to fetch Launch Darkly Client API key');
  }

  const data = await response.json();
  const decodedString = atob(data.base64Encoded);
  const appConfig = JSON.parse(decodedString);

  configJson.launchDarklyClientKey = appConfig;

  return appConfig;
}
